import React from 'react';
import AdvancedSearchResultType0 from './AdvancedSearchResultTypes/AdvancedSearchResultType0';

export default function AdvancedSearchResultSwitch({ type,data }) {

  switch (type) {
    case 0:
      return <AdvancedSearchResultType0 data={data} />;
    case 1:
      return <div>AdvancedSearchResultSwitch1</div>;
    case 2:
      return <div>AdvancedSearchResultSwitch2</div>;
    case 3:
      return <div>AdvancedSearchResultSwitch</div>;
  }
}
